module.exports = __webpack_public_path__ + "img/ic_baseline-facebook.586d3dc4.png";